import React, {Component} from 'react';
import {List, Modal, Button, Input, Pagination, Table} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {message} from "../sysManagement/utils/sysManagementUtils";
import {HEADER_HEIGHT} from "../../constants";
import {uuid} from "../../utils";
import {getAllMedia, MediaRoleEditForm} from "./mediaRoleEdit";
import PowerEdit from "./powerEdit";
import request from "../../base/request";
import $ from "jquery";
import BaseComponent from "../../base/BaseComponent";

const {Search} = Input;

class MediaRoleList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            sourceData: [],
            visible: false,
            modalTitle: "",
            modalContent: "",
            powerVisible: false,
            powerModalTitle: "",
            powerModalContent: "",
            mediaLimitsList: [],
            total: 0,
            page: 1,
            size: 10,
            searchValue: "",
            hideOnSinglePage: true
        }
    }

    initRoleData() {
        let params = {
            'page': this.state.page,
            'size': this.state.size,
        }
        if (this.state.searchValue) {
            params.queryStr = this.state.searchValue
        }
        getRoleList(params, (data) => {
            let sourceData = [];
            let total = 0;
            let hideOnSinglePage = true;
            if (data && data.data.length) {
                hideOnSinglePage = false;
                total = data.count;
                sourceData = data.data;
            }
            this.setState({
                sourceData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            })
        });
    }

    componentDidMount() {
        this.initRoleData();
        this.getMediaLimits();
    }

    getMediaLimits() {
        getAllMedia({}, (data) => {
            if (data) {
                this.setState({
                    mediaLimitsList: data
                })
            }
        })
    }

    editMediaRole(role) {
        this.setState({
            visible: true,
            modalTitle: "编辑角色-" + role.name,
            modalContent: <MediaRoleEditForm mediaLimitsList={this.state.mediaLimitsList} key={uuid()}
                                             ref={(that) => this.mediaRoleEdit = that}
                                             mediaRoleId={role.id} roleCode={role.code} roleName={role.name}
                                             deptId={role.deptId}/>
        });
    }

    handleOk = () => {
        let mediaRoleId = this.mediaRoleEdit.props.mediaRoleId ? this.mediaRoleEdit.props.mediaRoleId : 0;
        let mediaRoleEdit = this.mediaRoleEdit.getFieldsValue();
        if (!mediaRoleEdit.roleName || mediaRoleEdit.roleName.trim().length === 0) {
            message.error("请输入角色名称", 1);
            return;
        }
        if (!mediaRoleEdit.roleCode || mediaRoleEdit.roleCode.trim().length === 0) {
            message.error("请输入角色编码", 1);
            return;
        } else if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(mediaRoleEdit.roleCode))) {
            message.error("角色编码只可填写字母、数字、下划线及冒号，限制输入100个字符");
            return;
        }
        mediaRoleEdit.roleName = mediaRoleEdit.roleName && mediaRoleEdit.roleName.trim();
        mediaRoleEdit.roleCode = mediaRoleEdit.roleCode && mediaRoleEdit.roleCode.trim();
        mediaRoleEdit.roleDescribe = mediaRoleEdit.roleDescribe && mediaRoleEdit.roleDescribe.trim();
        let mediaIds = [];
        this.state.mediaLimitsList.length && this.state.mediaLimitsList.forEach(item => {
            if (mediaRoleEdit[item.mediaTypeCode] && mediaRoleEdit[item.mediaTypeCode].length) {
                mediaIds.push(...mediaRoleEdit[item.mediaTypeCode])
            }
        })
        let param = {
            'id': mediaRoleId,
            'name': mediaRoleEdit.roleName,
            'code': mediaRoleEdit.roleCode,
            'describe': mediaRoleEdit.roleDescribe,
            'mediaIds': mediaIds,
        };
        if (mediaRoleId) {
            param.deptId = this.mediaRoleEdit.props.deptId;
        }
        saveMediaRole(param, (data) => {
            if (data) {
                message.success("保存成功");
                this.setState({
                    visible: false,
                });
                this.initRoleData();
            } else {
                message.error("保存失败");
            }
        });
    };

    powerHandleOk = () => {
        this.powerEdit.savePowerRole();
        this.setState({
            powerVisible: false,
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };

    powerHandleCancel = () => {
        this.setState({
            powerVisible: false,
        });
    };

    roleEditModal;
    mediaRoleEdit;
    powerEditModal;
    powerEdit;

    addRole = () => {
        this.setState({
            visible: true,
            modalTitle: "新增角色",
            modalContent: <MediaRoleEditForm mediaLimitsList={this.state.mediaLimitsList} key={uuid()}
                                             ref={(that) => this.mediaRoleEdit = that}/>
        });
    }

    editRole(role) {
        this.setState({
            powerVisible: true,
            powerModalTitle: "编辑权限-" + role.name,
            powerModalContent: <PowerEdit key={uuid()} ref={(that) => this.powerEdit = that} roleId={role.id}
                                          roleCode={role.code} roleName={role.name}/>
        });
    }

    deleteRole(role) {
        Modal.confirm({
            title: '确认删除当前媒体角色？',
            onOk: () => {
                deleteMediaRoleById({id: role.id}, (data) => {
                    if (data) {
                        message.success("删除成功");
                        if (this.state.sourceData.length === 1) {
                            this.paginationOnChange(this.state.page - 1, this.state.size)
                        } else {
                            this.paginationOnChange(this.state.page, this.state.size)
                        }
                    } else {
                        message.error("删除失败");
                    }
                });
            }
        })
    }
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow";
        return className;
    };
    render() {
        // let border = 1;
        // let cardMargin = 15;
        // let h = parseInt(HEADER_HEIGHT) + cardMargin * 2 + border * 2 + 110;
        // let height = "calc(100vh - " + h + "px)";
        let height = window.innerHeight;

        const columns = [
            {
                title: '名称',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
                align:"left"
            },
            {
                title: '描述',
                key: 'describe',
                dataIndex: 'describe',
                ellipsis: true
            },
            {
                title: '操作',
                key: 'operate',
                render: (record) => {
                    return (
                        <div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer"}}>
                            <span style={{marginRight: 10}}
                                  onClick={() => this.editMediaRole(record)}>编辑</span>
                            <span style={{marginRight: 10}}
                                  onClick={() => this.editRole(record)}>编辑权限</span>
                            <span onClick={() => this.deleteRole(record)}>删除</span>
                        </div>
                    )
                }
            }
        ];

        return (
            <div id={"listItem"} style={{
                margin: "15px",
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px 5px 0 0",
                    height:70
                }}>
                    <Button style={{margin: "15px 0px 15px 15px"}} type={"primary"}
                            onClick={this.addRole}>新增角色</Button>
                    <Search placeholder={"请输入角色名称"} style={{width: 250, marginRight: "15px"}}
                            onSearch={(searchValue) => {
                                this.setState({searchValue, page: 1}, () => {
                                    this.initRoleData()
                                })
                            }}/>
                </div>
                <div style={{backgroundColor: "#ffffff", padding: "0 16px 10px 16px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={height - 234}>
                        <Table className={"tabList"}
                               rowClassName={this.getRowClassName} columns={columns} dataSource={this.state.sourceData}
                               pagination={false}/>
                    </Scrollbars>
                </div>
                <style>{`
                    #listItem .ant-list-item:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #listItem .ant-table-placeholder{border-bottom: 0;}
                     #listItem .ant-table-tbody > tr > td{padding: 22px 16px !important;}
                `}</style>
                {this.state.sourceData && this.state.sourceData.length>0 ? <div style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}

                <Modal ref={(that) => this.roleEditModal = that}
                       title={this.state.modalTitle}
                       visible={this.state.visible}
                       onCancel={this.handleCancel}
                       onOk={this.handleOk}
                       maskClosable={false}
                       width={650}
                >
                    {this.state.modalContent}
                </Modal>
                <Modal ref={(that) => this.powerEditModal = that}
                       title={this.state.powerModalTitle}
                       visible={this.state.powerVisible}
                       onCancel={this.powerHandleCancel}
                       onOk={this.powerHandleOk}
                       bodyStyle={{padding: "0px"}}
                       maskClosable={false}
                       width={800}
                >
                    {this.state.powerModalContent}
                </Modal>
            </div>
        );
    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.initRoleData();
    }
}

export default MediaRoleList;

export const host = "/cm-sites-pms/";
export const Apis = {
    getRoleList: host + 'mediaRole/list',
    saveMediaRoleAdd: host + 'mediaRole/add',
    saveMediaRoleEdit: host + 'mediaRole/edit',
    deleteMediaRoleById: host + 'mediaRole/deleteById'
};

export const getRoleList = (body, callBack) => {
    request({url: Apis.getRoleList, body, callBack});
};

export const saveMediaRole = (mediaRole, callBack) => {
    let url = Apis.saveMediaRoleAdd;
    if (mediaRole.id) {
        url = Apis.saveMediaRoleEdit;
    }
    request({url: url, body: mediaRole, contentType: "json", method: 'post', callBack});
};

export const deleteMediaRoleById = (body, callBack) => {
    request({url: Apis.deleteMediaRoleById, body, method: 'post', callBack});
};

export const flushMediaTree = (id, callBack) => {
    request({url: Apis.flushMediaTree, body: id, method: 'post', callBack});
};